import axios from "axios";

export default function Api() 

{
    const http = axios.create(
        {
        baseURL: 'https://ugpapi.mgu.ac.in/ugp/api/',
        headers: { 'Content-Type': 'application/json', },
        });

    http.interceptors.request.use(
        (config) => {
           
            const token = localStorage.getItem('token');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    return {
        http,
    };
};
